"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TShirtIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.605 2.895L13.104.838a.866.866 0 00-.443-.12h-2.33a.874.874 0 00-.875.873 1.456 1.456 0 11-2.912 0A.874.874 0 005.67.718H3.34a.867.867 0 00-.442.12L.395 2.896c.026-.021-.29.355-.395.707.036 0 0 1.173 0 1.173l.128 2.7a1.429 1.429 0 001.294.816h1.044v5.534a1.456 1.456 0 001.456 1.457h8.156a1.456 1.456 0 001.456-1.457V8.291h1.043a1.43 1.43 0 001.293-.814l.128-2.717.001-1.026s-.079-.65-.394-.84zM1.62 6.543l-.11-2.277.955-1.145v3.422h-.847zm10.168 6.99H4.213V2.466h.705a3.204 3.204 0 006.166 0h.703v11.069zm2.593-6.99h-.846V3.121l.954 1.147-.107 2.275z"
  })))
});
TShirtIcon.displayName = 'TShirtIcon';
var _default = exports.default = TShirtIcon;